<div class="extra-discounts">
  <h2>{{ titleKey() | translate }}</h2>
  <dl
    class="extra-discounts__list"
    [class.extra-discounts__list--usage]="showUsage()"
    [class.extra-discounts__list--readonly]="!removable()"
  >
    @if (!showUsage()) {
      <dt>{{ 'customer_groups.name' | translate }}</dt>
      <dt>{{ 'customer_groups.discount_amount' | translate }}</dt>
      @if (removable()) {
        <dt></dt>
      }
    }
    @for (
      discount of assignedDiscounts();
      track discount.discount_assignment_id ?? discount.id
    ) {
      @if (showUsage()) {
        <dd>{{ discount.name }}</dd>
        <dd class="bold">
          @if (discount.redeem_count) {
            {{ discount.redeem_count }}x
          }
          {{ discount.amount | number: '1.0-1' }}
          {{ 'customer_groups.cents' | translate }}
        </dd>
        <dd>
          @if (discount.is_expired) {
            <sui-badge icon="clock" size="xs" variant="soft" color="error">
              {{ 'discounts.statuses.expired' | translate }}
            </sui-badge>
          } @else if (!discount.discount_is_active) {
            <sui-badge icon="clock" size="xs" variant="soft" color="neutral">
              {{ 'discounts.statuses.inactive' | translate }}
            </sui-badge>
          } @else if (discount.consumed) {
            <sui-badge icon="check" size="xs" variant="soft" color="neutral">
              {{ 'discounts.statuses.used' | translate }}
            </sui-badge>
          } @else if (discount.redeem_count) {
            <sui-badge icon="check" size="xs" variant="soft" color="success">
              {{
                'discounts.usage_count'
                  | translate
                    : {
                        used: discount.usage ?? 0,
                        total: discount.redeem_count,
                      }
              }}
            </sui-badge>
          } @else {
            <sui-badge icon="check" size="xs" variant="soft" color="success">
              {{ 'discounts.statuses.unlimited' | translate }}
            </sui-badge>
          }
        </dd>
      } @else {
        <dd>{{ discount.name }}</dd>
        <dd class="bold">
          {{ discount.amount | number: '1.0-1' }}
          {{ 'customer_groups.cents' | translate }}
        </dd>
      }
      @if (removable()) {
        <dd>
          <sui-icon-button
            iconName="trash"
            size="xs"
            variant="ghost"
            color="neutral"
            (click)="onRemove(discount)"
          ></sui-icon-button>
        </dd>
      }
    } @empty {
      <dd class="extra-discounts__empty">
        {{ emptyKey() | translate }}
      </dd>
    }
  </dl>
</div>
